export default "__VITE_ASSET__2f660ed3__"